module.exports = __webpack_public_path__ + "bootleggeres_coffee_box_mockup_packaging_design_corrugated_box_arabica2.jpg?23baea5424957eb06b2b1ac8a606d6e1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/bootleggers/bootleggeres_coffee_box_mockup_packaging_design_corrugated_box_arabica2.jpg
// module id = 25
// module chunks = 0